import styled from 'styled-components';

const CheckBoxWrapper = styled.div`
  margin-top: 10px;
`;

CheckBoxWrapper.displayName = 'CheckBoxWrapper';

export default CheckBoxWrapper;
